import { ControllerModel } from "../_model/ControllerModel";
import { ProductionChangeEditable } from "./modelProductionChangeEditable";

class ControllerProductionChangeEditable extends ControllerModel {
  constructor() {
    super("ControllerProductionChangeEditable");
    
    this.setNewNode = (callback) => {
      let productionChange = new ProductionChangeEditable();
      productionChange.decorate(callback);

      this.addNode(productionChange);
    }

    this.getProperties = async (node) => {
      let n = new ProductionChangeEditable();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new ProductionChangeEditable();
      n.copyFrom(node);
      return n
    }

    this.loadNode = (node, callback) => {
      let productionChange = new ProductionChangeEditable();
      productionChange.copyFrom(node);
      productionChange.decorate(callback);
      this.addNode(productionChange)
    }
  } 
}

export { ControllerProductionChangeEditable };
